import axios from 'axios';
import store from "@/store/index";
import router from "@/router/router";
import website from "@/config/website";
import { Message } from 'edu-custom-ui';
import { getToken } from "@/utils/auth";
import { unencrypt, encrypt } from './encrypt';
// import NProgress from "nprogress"; // progress bar

// create an axios instance
const service = axios.create({
  timeout: 30000, // request timeout
});
//跨域请求，允许保存cookie
service.defaults.withCredentials = true;


// 需要加密的链接正则表达式，部署时开启
// const encryptPath = /^(\/api\/blade-workbench)/;,'blade-platform'
const encryptPath = ['blade-workbench','blade-platform'];
// const encryptPath = ['blade-workbench'];

// NProgress Configuration
// NProgress.configure({
//   showSpinner: false
// });

function testEncrypt(url) {
  return encryptPath.find(el => {
    return url.indexOf(el) !== -1
  })
}

service.interceptors.request.use(
  (config) => {
    // NProgress.start(); // start progress bar
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    config.headers["Authorization"] = `Basic ${Base64.encode(
      `${website.clientId}:${website.clientSecret}`
    )}`;
    if (getToken() && !isToken) {
      config.headers["Blade-Auth"] = "bearer " + getToken(); // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    }
    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }
    let key_id = store.state.user.userInfo.account;
    // let key_id = ''
    let user_name = store.state.user.userInfo.user_name;
    // let user_name = ''
    key_id = key_id == undefined ? "未获取/未登录" : key_id;
    user_name = user_name == undefined ? "未获取/未登录" : user_name;
    const isNeedEnrcy = testEncrypt(config.url)
    // 增加用户信息参数
    if (config.method !== "get") {
      // 如果是array
      if (Array.isArray(config.data)) {
        if (typeof config.data[0] == "object") {
          addUserInfo(config.data[0], key_id,user_name);
        }
      } // 如果是object
      else if (typeof config.data == "object") {
        addUserInfo(config.data, key_id,user_name);
      }
    }
    if (config.method === "get") {
      if (config.url.indexOf("?") !== -1) {
        config.url += "&user_info_id=" + key_id + "&user_info_name=" + user_name;
      } else {
        config.url += "?user_info_id=" + key_id + "&user_info_name=" + user_name;
      }
    }
    console.log(`请求url:${config.url} \n请求参数:`,config.data)
    // 加密操作，部署时开启
    if (isNeedEnrcy && config.method !== "get") {
      if (config.headers["Content-Type"] != "multipart/form-data") {
        config.data = {
          data: encrypt(config.data, config.url)
        };
      }
    }
    if (isNeedEnrcy && config.method === "get") {
      if (config.url.indexOf("?") !== -1) {
        config.url += "&time=" + new Date().getTime();
      } else {
        config.url += "?time=" + new Date().getTime();
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

service.interceptors.response.use(
  (res) => {
    // NProgress.done();
    const status = res.data.code || 200;
    const statusWhiteList = website.statusWhiteList || [];
    const message = res.data.msg || "未知错误";
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);
    //如果是401则跳转到登录页面
    if (status === 401)
      store.dispatch("FedLogOut").then(() => router.push({ path: "/login" }));
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message: message,
        type: "error"
      });
      return Promise.reject(new Error(message));
    }
    // 解密操作,部署时开启
    if (res.data && res.data.result && typeof res.data.result === "string") {
      try {
        res.data.result = unencrypt(res.data.result);
        console.log(`请求url:${res.request.responseURL} \n返回参数:}`, res)
      } catch (e) {
        console.error(e);
      }
    }
    return res;
  },
  (error) => {
    // NProgress.done();
    // Promise.reject(error);
    let msg = error.message
    const status = (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') != -1) ? 8010 : 8008;

    //如果是401则跳转到登录页面
    if (status === 401 || msg === 'Request failed with status code 401'){
        console.log(window.location);
      window.location.replace(window.location.origin + '/serviceManage');
    }

    if (status === 8010) {
      msg = "接口请求超时，请稍后重试"
    }
    return {
      data : {
        status: status,
        msg: msg
      }
    }
  },
);

export default service;


function addUserInfo(param, key_id, user_name) {
  if (param.user_info_id == undefined) {
    param.user_info_id = key_id;
    param.user_info_name = user_name;
  } else if (param.user_info_id_key_id == undefined) {
    param.user_info_id_key_id = key_id;
    param.user_info_id_key_name = user_name;
  }
}
